module.exports = __webpack_public_path__ + "static/media/product-placeholder.38f0ac03.png";